import { cn } from '@bem-react/classname';

export const cnEmptyContent = cn('EmptyContent');
